<div
    *ngIf="group"
    #chipContainer
    [id]="id"
    class="agpr-sourceGroupChip agpr-chip"
    [pTooltip]="group.name + ('Sources.type.sourceGroup' | localize)"
>
    <button
        class="agpr-chip-label"
        (click)="showPanel($event, chipContainer)"
    >
        {{ group.name }}
    </button>
    <span class="agpr-chip-type">{{ 'Sources.type.sourceGroup' | localize }}</span>
    <button
        [id]="id + '_delete'"
        class="agpr-chip-icon agpr-i-close"
        agprTooltip="Common.forms.chips.delete"
        [useTooltipAsAriaLabel]="false"
        tooltipPosition="top"
        (click)="remove.emit(groupId)"
        [attr.aria-label]="group.name + ' ' + ('Common.forms.chips.delete' | localize)"
    ></button>
</div>
<p-popover
    #chipPopover
    *ngIf="group"
    [id]="id + '_chipPopover'"
    [appendTo]="'body'"
    [baseZIndex]="1000"
    styleClass="agpr-clickOutsideExcluded agpr-sourceGroupChip-popover"
    (onHide)="onHide()"
>
    <div
        class="agpr-sourceGroupChip-popover-content"
    >
        <div class="agpr-sourceGroupChip-popover-heading">
            <div class="agpr-sourceGroupChip-popover-heading-groupName">
                "{{ group.name }}" {{ 'SourceGroup.group' | localize }}
            </div>
            <div class="agpr-sourceGroupChip-popover-heading-buttons">
                <agpr-button
                    class="agpr-sourceGroupChip-popover-button agpr-sourceGroupChip-popover-button-edit"
                    icon="fa-regular fa-duotone fa-pencil"
                    tooltip="edit"
                    tooltipPosition="top"
                    [style]="buttonTypes.icon"
                    (click)="editGroup()"
                    (keydown)="onPanelKeydown($event)"
                ></agpr-button>
                <agpr-button
                    class="agpr-sourceGroupChip-popover-button agpr-sourceGroupChip-popover-button-close"
                    icon="fa-regular fa-duotone fa-close"
                    tooltip="close"
                    tooltipPosition="top"
                    [style]="buttonTypes.icon"
                    (click)="chipPopover.hide(); onHide();"
                    (keydown)="onPanelKeydown($event)"
                ></agpr-button>
            </div>
        </div>
        <agpr-scroll-panel>
            <ul
                #overlayChipList
                [id]="id + '_chipList_popover'"
                class="agpr-sourceGroupChip-list agpr-sourceGroupChip-list--popover"
                agprListKeyboardNavigation
                listOrientation="horizontal"
                [focusOnChild]="true"
                [list]="sourceChips"
            >
                <li
                    *ngFor="let chip of sourceChips; let i = index"
                    [id]="id + '_popover_chip_' + i"
                    class="agpr-chip"
                    [attr.aria-label]="chip.label"
                >
                    <span
                        class="agpr-chip-label"
                    >
                        {{ chip.label }}
                    </span>
                    <span
                        class="agpr-chip-type"
                    >
                        {{ chip.type }}
                    </span>
                </li>
            </ul>
        </agpr-scroll-panel>
    </div>
</p-popover>
